/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { DOWNLOAD_APP_BANNER_BG } from '@common/Assets/images'

export const SearchResultStyled = styled.div`

.didYouMeanContainer {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
}

.plp-banner {
  margin-bottom: 23px;
  .box {
    display: block;
    cursor: pointer;
    height: 104px;
    & > div {
      > img {
        width: 770px !important;
        padding-right: 14px !important;
        border-radius: 0px !important;
        min-height: 0px !important;
      }
    }
  }
  
  .slick-dots {
    li {
      button {
        display: none !important;
      }
      &.slick-active {
        button {
          display: none !important;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .plp-banner {
  .box {
    & > div {
      > img {
        width: 700px !important;
        padding-right: 14px !important;
        border-radius: 0px !important;
        min-height: 0px !important;
      }
      }
    }
  }
}
@media (max-width: 415px) {
  .plp-banner {
    .slick-slide {
      
      img {
        border: 0 !important;
      }
    }
  .box {
    & > div {
      > img {
        width: 345px !important;
        padding-right: 14px !important;
        border-radius: 0px !important;
        min-height: 0px !important;
      }
      }
    }
  }
}
.didYouMean {
  width: 104px;
  font-family: Mulish;
  font-size: 15px;
  margin: 0 auto;
  font-weight: 600;
  white-space: nowrap;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  color: #78909C;
  padding-bottom: 10px;
}


.container_nosearch {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: 22px;
  background: #ffffff;
  /* width: 25%;
  margin: auto; */
}

.item_nosearch {
  width: auto;
  height: 35px;
  margin: 4px;
  text-align: center;
  border: 1px solid #e3e9ef;
  box-sizing: border-box;
  line-height: 19px;
  border-radius: 6px;
  font-family: Mulish;
  font-size: 15px;
  letter-spacing: 0em;
  font-weight: 600;
  color: #388e3c;
  padding-left: 5px;
  padding-top: 5px;
  padding-right: 5px;
  cursor: pointer;
  white-space: nowrap;        
  overflow: hidden;          
  text-overflow: ellipsis;    
}


  .stickySortBy {
    width: 100%;
    background: ${(props) => props?.theme?.sectionBox?.bodyBg};
    border-bottom: 1px solid ${(props) => props?.theme?.color?.borderLight};
    padding: 0 6px 16px 6px;
    position: relative;
    z-index: 11;
    display: flex;
    justify-content: space-between;

    &.stickyTop80 {
      position: sticky;
      top:80px;
    }

    &.sticky {
      position: sticky;
      top: 112px;

      .titleBar {
        padding: 16px 0 0 0 !important;
      }
    }

      .oosMessage{
        font-family: Mulish;
        padding: 16px 6px;
        font-size: 18px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: 0px;
    }

    .titleBar {
      width: 100%;
      padding: 0 !important;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      h2 {
        &.title {
          width: calc(100% - 260px);
          margin: 0;
          font-size: 18px;
          font-weight: 700;
          display: flex;
          flex-wrap: wrap;

          .resultText {
            width: 100%;
            display: flex;
          }

          .label {
            width: auto;
            display: inline-flex;
            font-weight: 400;
            margin-right: 5px;
          }

          .searchedText {
            width: auto;
            max-width: calc(100% - 100px);
            padding-left: 8px;
            padding-right: 8px;
            position: relative;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-size: 18px;

            &::before {
              content: '"';
              position: absolute;
              top: 0;
              left: 0;
            }
            &::after {
              content: '"';
              position: absolute;
              top: 0;
              right: 0;
            }
          }

          .quotedtext {
            width: 100%;
            max-width: 100%;
            flex: 1;
            max-width: max-content;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            display: inline;
          }

          .subTitle {
            width: 100%;
            font-weight: normal;
            font-size: 14px;
            color: ${(props) => props?.theme?.text?.medium};
            margin: 5px 0 0 0;
          }
        }
      }

      .dropDownContent {
        display: flex;
        flex-direction: row;
        align-items: center;

        .label {
          color: ${(props) => props?.theme?.text?.medium};
          min-width: 55px;
          font-weight: 600;
          font-size: 14px;
          margin-left: 5px;
        }

        .dropdown-toggle {
          width: 197px;
          height: 40px;
          padding: 7px 35px 8px 15px;
          font-size: 14px;
          font-weight: 700;
        }
      }

      .showFilter {
        width: 40px;
        height: 40px;
        min-width: 40px;
        position: relative;
        margin-left: auto;
      }
    }
  }

  .searchStickySortBy {
    width: 100%;
    background: ${(props) => props?.theme?.sectionBox?.bodyBg};
    padding: 16px 6px 12px;
    position: relative;
    z-index: 11;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.sticky {
      position: sticky;
      top: 80px;
    }

    .suggested-products {
      font-size: 18px;
      font-weight: 700;
    }

    .oosMessage{
        font-family: Mulish;
        padding-top: 17px;
        font-size: 18px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: left;
        width: 262px;
        height: 18px;
        top: 235px;
        left: 409px;
      }

      h2 {
        &.title {
          width: calc(100% - 260px);
          margin: 0;
          font-size: 18px;
          font-weight: 700;
          display: flex;
          flex-wrap: wrap;

          .resultText {
            width: 100%;
            display: flex;
          }

          .resultText.ltr {
            justify-content: flex-end;
            text-align: right;
            direction: ltr;
          }

          .resultText.rtl {
            justify-content: flex-start;
            text-align: left;
            direction: rtl;
          }

          .label {
            width: auto;
            display: inline-flex;
            font-weight: 400;
            margin-right: 5px;
          }

          .searchedText {
            width: auto;
            max-width: calc(100% - 100px);
            padding-left: 8px;
            padding-right: 8px;
            position: relative;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-size: 18px;

            &::before {
              content: '"';
              position: absolute;
              top: 0;
              left: 0;
            }
            &::after {
              content: '"';
              position: absolute;
              top: 0;
              right: 0;
            }
          }

          .quotedtext {
            width: 100%;
            max-width: 100%;
            flex: 1;
            max-width: max-content;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            display: inline;
          }

          .subTitle {
            width: 100%;
            font-weight: normal;
            font-size: 14px;
            color: ${(props) => props?.theme?.text?.medium};
            margin: 5px 0 0 0;
          }
        }
      }

      .dropDownContent {
        display: flex;
        flex-direction: row;
        align-items: center;

        .label {
          color: ${(props) => props?.theme?.text?.medium};
          min-width: 55px;
          font-weight: 600;
          font-size: 14px;
        }

        .dropdown-toggle {
          width: 197px;
          height: 40px;
          padding: 7px 35px 8px 15px;
          font-size: 14px;
          font-weight: 700;
        }
      }

      .showFilter {
        width: 40px;
        height: 40px;
        min-width: 40px;
        position: relative;
        margin-left: auto;
      }
  }

  .disclaimer-scheduled-wrapper{
    display: flex;
    align-items: center;
    width: auto;
    height: 46px;
    margin: 16px 0px 10px 0px;
    gap: 6px;
    border-radius: 8px;
    background: ${(props) => props?.theme?.colors?.accent?.yellow['25']};
    border: 1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};

    .diclaimer-img{
      padding-left: 8px;
      margin-top: 10px;
    }

    .disclaimer-scheduled-text{
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      text-align: left;
      padding-top: 2px;
    }
  }

  .fixedPayButton {
    display: none;
  }

  .product-outer-wrapper {
    background: transparent;
    border: none;

    .titleBar {
      h2 {
        &.title {
          margin: 14px 0 0 14px;
          flex-wrap: wrap;
        }
        .light-text {
          font-weight: 400;
          margin-right: 5px;
        }
        > span {
          width: 95%;
          display: flex;
          flex-wrap: nowrap;
        }
        &.title:not(.notruncet) {
          > span {
            width: 95%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            display: inline-block;
          }
        }
        .quotedtext {
          flex: 1;
          width: calc(100% - 80px);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: inline;
          max-width: max-content;
        }
      }
    }
    &.remove-light-text-spacing {
      .titleBar {
        h2 {
          .light-text {
            margin-right: 0;
          }
        }
      }
    }
    .product-card-section {
      display: flex;
      flex-wrap: wrap;
      .product-card-wrapper {
        width: 25%;
        padding: 0;
        .dealItemBox {
          position:relative;
          max-width: 100%;
          margin: 6px 5px;
        }
      }
    }
  }

  &.five {
    .product-outer-wrapper {
      .product-card-section {
        .product-card-wrapper {
          width: 20%;
        }
      }
    }
  }

  .no-background {
    .card_wrapper {
      background: transparent;
    }
  }
  .no-search-result-found-container {
    .titleBar {
      border-bottom: 0px !important;
    }
  }
  .card_wrapper {
    > div {
      display: block !important;
    }
    p {
      &.title {
        margin: 20px 0 10px 0;
      }

      &.subtitle {
        max-width: 276px;
        margin: 0 auto;
      }
    }
  }
  .search-title-wrapper {
    .titleBar {
      width: calc(100% - 12px);
      border-bottom: 1px solid ${(props) => !props?.isOOSSearch ? props.theme.color.lightGray : 'none'};
      padding: 0 0 16px 0;
      margin: 0 6px 10px 6px;

      h2.title {
        width: 60%;
        margin: 14px 0 0 0;
      }
    }
    .dropdown-container {
      margin-right: 0 !important;
    }
  }
  .recommended-product-slider {
    .slick-list {
      margin: 0 0;
      width: 100%;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    .product-outer-wrapper {
      .titleBar {
        flex-wrap: wrap;
      }
      .dropdown-container {
        margin: 14px 0px 0 14px;
      }
      .product-card-section {
        .product-card-wrapper {
          width: 20%;
        }
      }
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    .product-outer-wrapper {
      .titleBar {
        flex-wrap: wrap;
      }
      .dropdown-container {
        margin: 14px 0px 0 14px;
      }
      .product-card-section {
        .product-card-wrapper {
          width: 33%;
        }
      }
    }
  }
  @media only screen and (min-width: 575px) and (max-width: 767px) {
    .product-outer-wrapper {
      .titleBar {
        flex-wrap: wrap;
      }
      .dropdown-container {
        margin: 14px 0px 0 14px;
      }
      .product-card-section {
        .product-card-wrapper {
          width: 33%;
        }
      }
    }
  }
  @media only screen and (max-width: 574px) {

    .oosMessage {
    display: none;
  }

  .suggested-products {
    margin-bottom: 10px;
  }

  .searchStickySortBy {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .search-sort-by-container {
    margin-top: 200px;
  }
    .searchPageHeader {
      &.fixed {
        .container {
          .content {
            min-height: 1px;
            opacity: 0;
            position: relative;
            transition: 0.4s linear min-height;
            > * {
              position: absolute;
            }
          }
          .mobileSearchBox {
            margin-top: 0;
          }
        }
      }
    }
    .product-detail-container {
      .plpPage {
        padding-left: 0;
        padding-right: 0;
      }

      .row {
        margin-left: 0;
        margin-right: 0;

        .col-md-3,
        .col-md-9 {
          padding: 0;
        }
      }

      .breadcrumbsRow {
        padding: 0 16px;
      }

      .pageContent {
        position: relative;
      }

      .stickySortBy {
        padding: 0 16px 16px 16px;

        &.sticky {
          .titleBar {
            padding-top: 0 !important;

            h2 {
              &.title {
                display: none;
              }
            }
          }
          .dropDownContent {
            margin-top: 16px;
          }
        }

        .titleBar {
          h2 {
            &.title {
              width: 100%;
              margin: 0;
              font-size: 15px;
              font-weight: 700;
              display: flex;
              flex-wrap: wrap;

              .resultText {
                width: 100%;
                display: flex;
              }

              .label {
                width: auto;
                display: inline-flex;
                font-weight: 400;
                margin-right: 5px;
              }

              .searchedText {
                width: auto;
                max-width: calc(100% - 80px);
                padding-left: 6px;
                padding-right: 6px;
                position: relative;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;

                &::before {
                  content: '"';
                  position: absolute;
                  top: 0;
                  left: 0;
                }
                &::after {
                  content: '"';
                  position: absolute;
                  top: 0;
                  right: 0;
                }
              }
            }

            .quotedtext {
              width: 100%;
              max-width: 100%;
              flex: 1;
              max-width: max-content;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              display: inline;
            }

            .subTitle {
              display: none;
            }
          }
        }

        .dropDownContent {
          margin-top: 12px;
          width: 100%;
        }
      }

      .mainContentPLP {
        position: relative;

        .titleBar {
          flex-direction: column;

          .title {
            width: 100%;

            > span {
              width: 100%;
            }
          }

          .sub-title {
            display: none;
          }

          .dropdown-container {
            position: static;
            top: 120px;
          }
        }
        .dropDownContent {
          position: relative;
        }
      }

      .dropdown-container {
        margin: 14px 0px 0 0;
      }
      .product-card-section {
        margin: 0;

        .product-card-wrapper {
          width: 50%;
        }
      }
    }
    .card_wrapper {
      padding: 110px 20px 40px 20px;
    }

    &.page_plp {
      .pageContent {
        .breadcrumb {
          .breadcrumb-item {
            a,
            &.active {
              font-size: 12px;
            }
          }
        }
        .tostControl {
          .newVariantGreen {
            &.floating-wrapper {
              top: 80px;
            }
          }
        }
        .search-title-wrapper {
          .titleBar {
            .title {
              font-size: 15px;
              margin-top: 5px;
            }
            .sub-title {
              font-size: 12px;
            }
            .dropdown-container {
              .dropdown-label {
                min-width: 51px;
                font-size: 11px;
              }
              .dropdown {
                .dropdown-toggle {
                  font-size: 12px;
                }
              }
              .dropdown-menu {
                .dropdown-item {
                  font-size: 12px;
                  padding: 8px 20px 9px 20px;
                }
              }
            }
          }
        }
        .product-card-section {
          padding-top: 0;
          margin-left: 0;
          margin-right: 0;

          .product-card-wrapper {
            .dealItemBox {
              width: calc(100% - 10px);

              .item {
                padding: 10px;

                .badgeStack {
                  .wrapper {
                    font-size: 11px;
                  }
                }
                .addToWishList {
                  top: 10px;
                  right: 10px;
                }
                .imgWrapper {
                  padding-bottom: 0;
                  .img {
                    width: 100px;
                    height: 100px;
                  }
                }
                .name {
                  height: 50px;
                  font-size: 14px;
                  line-height: 17px;
                  margin-bottom: 2px;
                }
                .price {
                  font-size: 13px;
                  margin-bottom: 2px;

                  .new {
                    font-size: 14px;
                  }
                }
                .delivery {
                  height: 30px;
                  background-position: 0 5px;
                  font-size: 10px;
                  line-height: 14px;
                  margin-bottom: 4px;
                }
                .add-to-card {
                  .btn {
                    font-size: 12px;
                    padding: 5px 10px;
                  }
                }
              }
            }
          }
        }
        .pagination-container {
          margin: 12px 0;

          .pagination-item {
            min-width: 32px;
            height: 32px;
            font-size: 14px;
          }
        }
        .page_plp_hereToHelp {
          .text {
            font-size: 16px;
            margin-bottom: 10px;
          }
        }
        .page_plp_footer {
          .topArea {
            padding: 15px 0;

            .container {
              margin-bottom: 0;
            }

            .leftArea {
              margin: 0 0 10px 0;

              .footer-label-text {
                font-size: 14px;
              }
            }

            .rightArea {
              .sectionArea {
                margin: 0 0 10px 0;
                .title {
                  font-size: 14px;
                  margin: 0 0 5px 0;
                  padding: 0 0 5px 0;
                }
                ul {
                  li {
                    margin: 0 0 5px 0;
                  }
                  &.social {
                    margin-top: 5px;
                    li {
                      margin: 0 8px 5px 0;
                    }
                  }
                }
              }
              .storeLink {
                margin-top: 15px;
              }
            }
          }

          .bottomArea {
            .container {
              .links {
                margin: 0 0 10px 0;
              }
            }
          }
        }
      }
    }

    .fixedPayButton {
      width: 100%;
      background: ${(props) => props?.theme?.color?.white};
      border-top: 1px solid ${(props) => props?.theme?.color?.borderLight};
      padding: 16px;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 100;
      display: flex;
      flex-direction: row;
      align-items: center;

      .totalCount {
        width: 100%;
        padding-right: 16px;
        display: flex;
        flex-direction: column;

        .itemCount {
          color: ${(props) => props?.theme?.text?.medium};
          font-size: 15px;
          line-height: 18px;
          font-weight: 600;
        }

        .amount {
          font-size: 18px;
          line-height: 20px;
          font-weight: 700;
        }
      }

      .btn {
        width: 230px;
        height: 60px;
        font-size: 16px;
        line-height: 16px;
        margin-right: 0;
        padding: 12px;
      }
    }
  }

  @media (max-width: 980px) {
    &.five {
      .product-outer-wrapper {
        .product-card-section {
          .product-card-wrapper {
            width: 25%;
          }
        }
      }
    }
  }
  @media (max-width: 820px) {
    &.five {
      .product-outer-wrapper {
        .product-card-section {
          .product-card-wrapper {
            width: 33%;
          }
        }
      }
    }
  }
  @media (max-width: 480px) {

    .search-title-wrapper {
      .titleBar {
        display: none;
      }
    }

    .dealItemBox {
      .add-to-card {
        .quantity-wrapper {
          .dropdown-toggle {
            height: 43px !important;
            font-size: 13px !important;
            padding: 5px 30px !important;

            .txtLoading {
              font-size: 11px !important;
            }
          }
          .decrease-product {
            width: 20px;
            height: 32px;
            position: absolute;
            left: 6px;
            top: 5px;

            img {
              width: 38px;
              top: 6px;
              left: 0;
            }
          }

          .increase_product {
            width: 20px;
            height: 32px;
            right: 6px;
            top: 5px;

            img {
              width: 38px;
              top: 6px;
              right: 0;
            }
          }
        }
      }
    }

    .product-detail-container {
      padding: 0;
    }
    .product-outer-wrapper {
      .titleBar {
        border-bottom: 0;
      }

      .product-card-section {
        .product-card-wrapper {
          .dealItemBox {
            width: 100% !important;
            margin: 0;

            .item {
              border-radius: 0;
              border-top: 0;
            }
          }

          &:nth-child(odd) {
            .dealItemBox {
              .item {
                border-left: 0;
              }
            }
          }

          &:nth-child(even) {
            .dealItemBox {
              .item {
                border-right: 0;
              }
            }
          }
        }
      }
    }
    &.five {
      .product-outer-wrapper {
        .product-card-section {
          .product-card-wrapper {
            width: 50%;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
  .container_nosearch {
    width: auto;
  }
}

  @media (max-width: 380px) {
    .stickySortBy {
      .titleBar {
        .dropDownContent {
          .dropdown-toggle {
            width: 160px;
          }
        }
      }
    }

    .searchStickySortBy {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      .suggested-products {
        font-size: 14px;
        font-weight: 700;
        padding-bottom: 8px;
      }
        .dropDownContent {
          display: flex;
          justify-content: space-evenly;
          width: 100%;
          .dropdown-toggle {
            width: 160px;
          }
        }
    }

    .fixedPayButton {
      .btn {
        width: 160px;
      }
    }
  }
  
  .download-app-banner {
    position: relative;
    background-image: url(${DOWNLOAD_APP_BANNER_BG.src});
    background-size: cover;
    border-radius: 8px;
    overflow: hidden;
    color: ${(props) => props?.theme?.color?.white};
    padding: 26px 32px 32px 32px;
    cursor: pointer;
    .banner-title {
      font-size: 28px;
      font-weight: 700;
      line-height: 32px;
    }
    .banner-subtitle {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin: 20px 0 15px 0;
    }
    .app-icon-wrapper {
      display: flex;
      gap: 24px;
    }
    .hand-mobile-img-wrappoer {
      position: absolute;
      bottom: -60px;
      right: -42px;
      img {
        width: 180px;
      }
    }
  }
  @media (max-width: 850px) {
    .download-app-banner {
      .hand-mobile-img-wrappoer {
        bottom: -50px;
        right: -32px;
        img {
          width: 132px;
        }
      }
    }
  }
  @media (max-width: 370px) {
    .download-app-banner {
      .hand-mobile-img-wrappoer {
        bottom: 0px;
        right: -32px;
        img {
          width: 80px;
        }
      }
    }
  }
  .rtl {
    &.download-app-banner {
      .hand-mobile-img-wrappoer {
        left: -32PX;
        right: auto;
      }
    }
    @media (max-width: 370px) {
      &.download-app-banner {
        .hand-mobile-img-wrappoer {
          left: -32px;
          right: auto;
        }
      }
    }
  }
  .stickySortBy {
    .titleBar {
      .rtl {
        & > .dropdown {
          .dropdown-toggle {
            direction: rtl;
            text-align: right;
            padding: 8px 15px 8px 35px;
            &::after {
              left: 15px;
              right: auto;
            }
          }
        }
      }
    }
  }
`;

